import AcceptedIcon from "../Icons/AcceptedIcon";
import Navbar from "../Layout/Navbar";
import { EssayQuizResponse } from "../../api/Quiz/SubmitEssayQuiz";
import { Link } from "react-router-dom";
import Button from "../Shared/Button";
import ReactMarkdown from "react-markdown";
import rehypeRaw from 'rehype-raw';

const PostEssayQuiz = ({
    submissionResponse,
    courseId,
    lectureId,
  }: {
    submissionResponse?: EssayQuizResponse;
    courseId?: string;
    lectureId?: string;
  }) => {
    if (!submissionResponse) {
        return <div>No submission data available.</div>;
    }

    const { quizTitle, quizDetails } = submissionResponse;
    const { score, status, num_tries, question } = quizDetails;

    return (
        <>
            <Navbar />
            <div id="table" className="sm:pb-20 pb-10 md:pt-40 sm:pt-32 pt-20  w-full h-full max-w-5xl mx-auto container">
                <div className=" flex justify-center flex-col items-center sm:max-w-xl max-w-md mx-auto">
                    <div className="bg-[#DFF8E4] sm:px-14 px-10 sm:py-20 py-14 gap-4  w-full rounded-3xl flex flex-col items-center justify-between ">
                        <AcceptedIcon />
                        <h1 className="text-center text-[#55CF86] sm:text-2xl text-lg font-bold">
                            Your essay has been submitted successfully
                        </h1>
                    </div>
                    <h1 className="mt-6 font-semibold text-secondaryText">
                    {quizTitle}
                    </h1>
                </div>
                <Link to={`/lecture/${courseId}/${lectureId}`}>
            <Button
              className="w-full mt-10 md:!h-16 !h-12 md:!text-xl !text-base"
              variant="primary"
            >
              Back To Lecture
            </Button>
          </Link>

                <div className="mt-6 px-4 bg-white py-10 rounded-xl">
                    <h2 className="text-xl font-bold"></h2>
                    <p className="mt-2">Percentage: {score}%</p>
                    <p>Number of tries: {num_tries}</p>
                    <p>Student Status: {status}</p>
                    <div className="mt-4 space-y-4">
                        {question.map((q, index) => (
                            <div key={index} className="mb-4 p-4 border-primary border rounded-md">
                                <h3 className="font-bold mb-2">Question: 
                                    <ReactMarkdown className="text-justify" rehypePlugins={[rehypeRaw]}>
                                        {q.question}
                                    </ReactMarkdown></h3>
                                <p className="sm:text-base text-sm">
                                    Explanation: 
                                    <ReactMarkdown className="text-justify" rehypePlugins={[rehypeRaw]}>
                                        {q.explanation}
                                    </ReactMarkdown>
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default PostEssayQuiz;
